import { render, staticRenderFns } from "./GMBsPage.vue?vue&type=template&id=32f3d48a&"
import script from "./GMBsPage.vue?vue&type=script&lang=js&"
export * from "./GMBsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32f3d48a')) {
      api.createRecord('32f3d48a', component.options)
    } else {
      api.reload('32f3d48a', component.options)
    }
    module.hot.accept("./GMBsPage.vue?vue&type=template&id=32f3d48a&", function () {
      api.rerender('32f3d48a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/GMBsPage.vue"
export default component.exports